import React from "react";
import {
  StyledSection,
  StyledFigure,
  StyledHandImage,
  StyledBottleImage,
  StyledBottleBlurImage,
  StyledSmokeImage,
} from "./Landing.styled";
import hand from "../../../assets/images/hero-hand.png";
import bottle from "../../../assets/images/bottle.png";
import smoke from "../../../assets/images/smoke-0.jpg";

export interface LandingProps {
  isActive?: boolean;
}

export const Landing: React.FC<LandingProps> = ({ isActive }) => {
  return (
    <StyledSection className={`${isActive && "is-active"}`}>
      <StyledFigure>
        <StyledSmokeImage src={smoke} alt={`smoke`} />
        <StyledHandImage src={hand} alt={`hero hand`} />
        <StyledBottleImage src={bottle} alt={`hero bottle`} />
        <StyledBottleBlurImage src={bottle} alt={`hero bottle blur`} />
      </StyledFigure>
    </StyledSection>
  );
};
